export default {
    RefundedGiftReport: 'Date Gift Expired/Refunded Start',
    SalesReport: 'Date Sold Start',
    EnrolledGiftReport: 'Date Enrolled Start',
    PromoCodeUsageReport: 'Date of Promo Sale Start',
    RedemptionCodeUsageReport: 'Date Redemption Enrolled Start',
    ContactUsSubmissionsReport: 'Date Submitted Start',
    CrossTerritorySalesReport: 'Date Sold Start'
}